import { highLevelApi } from '@sdk/main'
import type { PaginatedData } from '@lib/types/paginatedData'
import type { Event, EventRequest, PatchedEventRequest } from '@openapi'

export function getEvents(payload: Partial<EventRequest>): Promise<PaginatedData<Event>> {
  return highLevelApi.API.request('get_events', payload)
}

export function createEvent(payload: EventRequest): Promise<Event> {
  return highLevelApi.API.request('create_event', payload)
}

export function updateEvent(payload: PatchedEventRequest): Promise<Event> {
  return highLevelApi.API.request('update_event', payload)
}

export function deleteEvent(payload: Partial<Event>): Promise<void> {
  return highLevelApi.API.request('delete_event', payload)
}
